import { Icon } from '@chakra-ui/react';
import {
  MdEvent,
  MdFeedback,
  MdGroups,
  MdHandshake,
  MdInfo,
  MdLogin,
  MdPeople,
  MdPostAdd,
  MdSettings,
  MdSubscriptions,
  MdPlace,
  MdAirlineSeatReclineNormal,
  MdConfirmationNumber,
  MdBarChart,
  MdQrCodeScanner,
  MdCollections,
  MdPayment,
} from 'react-icons/md';
import { RiCoupon3Line } from 'react-icons/ri';

// Admin Imports
import BlogPostTable from 'views/admin/blogpost';
import CommunityTable from 'views/admin/communities';
import Settings from 'views/admin/settings';
import SponsorTable from 'views/admin/sponsor';
import UserTable from 'views/admin/UserTable';
// import ContactUs from 'views/admin/contact-us';
import AboutUs from 'views/admin/about-us';
import EventTable from 'views/admin/events';
import EventForm from 'views/admin/events/EventForm';
import Feedbacks from 'views/admin/feedbacks';
import Subscribers from 'views/admin/subscribers';
import VenuesView from 'views/admin/venues';
import SeatingPlansView from 'views/admin/seating-plans';
import SeatingPlanEditorView from 'views/admin/seating-plans/editor';
import VouchersView from 'views/admin/vouchers';
import PaymentGatewaysView from 'views/admin/payment-gateways';
import CheckInView from 'views/admin/check-in';
import CarouselSlides from 'views/admin/carousel';
import Gallery from 'views/admin/gallery';
import EventHighlights from 'views/admin/event-highlights';
import Videos from 'views/admin/videos';
import { MdViewCarousel, MdVideoLibrary, MdAutoAwesome } from 'react-icons/md';

import SignIn from 'views/auth/signIn';
import TicketsTable from 'views/admin/tickets/TicketsTable';
import ReportsAnalyticsView from 'views/admin/reports';
import CancellationsView from 'views/admin/cancellations';
import ReconciliationIndex from 'views/admin/reconciliation';
import WaitlistIndex from 'views/admin/waitlist';
import { MdAssignmentReturn, MdSecurity, MdPlaylistAddCheck } from 'react-icons/md';

const routes = [
  {
    name: 'Users',
    layout: '/admin',
    path: '/users',
    icon: <Icon as={MdPeople} width="20px" height="20px" color="inherit" />,
    component: <UserTable />,
  },
  {
    name: 'Events',
    layout: '/admin',
    path: '/events',
    icon: <Icon as={MdEvent} width="20px" height="20px" color="inherit" />,
    component: <EventTable />,
  },
  {
    name: 'Create Event',
    layout: '/admin',
    path: '/events/create',
    component: <EventForm />,
    noSidebar: true,
  },
  {
    name: 'Edit Event',
    layout: '/admin',
    path: '/events/:id/edit',
    component: <EventForm />,
    noSidebar: true,
  },
  {
    name: 'Venues',
    layout: '/admin',
    path: '/venues',
    icon: <Icon as={MdPlace} width="20px" height="20px" color="inherit" />,
    component: <VenuesView />,
  },
  {
    name: 'Seating Plans',
    layout: '/admin',
    path: '/seating-plans',
    icon: <Icon as={MdAirlineSeatReclineNormal} width="20px" height="20px" color="inherit" />,
    component: <SeatingPlansView />,
  },
  {
    name: 'Seating Plan Editor',
    layout: '/admin',
    path: '/seating-plans/:id/edit',
    component: <SeatingPlanEditorView />,
    noSidebar: true,
  },
  {
    name: 'Vouchers',
    layout: '/admin',
    path: '/vouchers',
    icon: <Icon as={RiCoupon3Line} width="20px" height="20px" color="inherit" />,
    component: <VouchersView />,
  },
  {
    name: 'Payment Gateways',
    layout: '/admin',
    path: '/payment-gateways',
    icon: <Icon as={MdPayment} width="20px" height="20px" color="inherit" />,
    component: <PaymentGatewaysView />,
  },
  {
    name: 'Tickets',
    layout: '/admin',
    path: '/tickets',
    icon: <Icon as={MdConfirmationNumber} width="20px" height="20px" color="inherit" />,
    component: <TicketsTable />,
  },
  {
    name: 'Cancellations',
    layout: '/admin',
    path: '/cancellations',
    icon: <Icon as={MdAssignmentReturn} width="20px" height="20px" color="inherit" />,
    component: <CancellationsView />,
  },
  {
    name: 'Reconciliation',
    layout: '/admin',
    path: '/reconciliation',
    icon: <Icon as={MdSecurity} width="20px" height="20px" color="inherit" />,
    component: <ReconciliationIndex />,
  },
  {
    name: 'Waitlist',
    layout: '/admin',
    path: '/waitlist',
    icon: <Icon as={MdPlaylistAddCheck} width="20px" height="20px" color="inherit" />,
    component: <WaitlistIndex />,
  },
  {
    name: 'Reports & Analytics',
    layout: '/admin',
    path: '/reports',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    component: <ReportsAnalyticsView />,
  },
  {
    name: 'Gate Check-In',
    layout: '/admin',
    path: '/check-in',
    icon: <Icon as={MdQrCodeScanner} width="20px" height="20px" color="inherit" />,
    component: <CheckInView />,
    roles: ['admin'],
  },
  {
    name: 'Carousel',
    layout: '/admin',
    path: '/carousel',
    icon: <Icon as={MdViewCarousel} width="20px" height="20px" color="inherit" />,
    component: <CarouselSlides />,
  },
  {
    name: 'Blog Posts',
    layout: '/admin',
    path: '/blog_posts',
    icon: <Icon as={MdPostAdd} width="20px" height="20px" color="inherit" />,
    component: <BlogPostTable />,
  },
  {
    name: 'Sponsors',
    layout: '/admin',
    path: '/sponsors',
    icon: <Icon as={MdHandshake} width="20px" height="20px" color="inherit" />,
    component: <SponsorTable />,
  },
  {
    name: 'Communities',
    layout: '/admin',
    path: '/communities',
    icon: <Icon as={MdGroups} width="20px" height="20px" color="inherit" />,
    component: <CommunityTable />,
  },
  {
    name: 'Gallery',
    layout: '/admin',
    path: '/gallery',
    icon: (
      <Icon as={MdCollections} width="20px" height="20px" color="inherit" />
    ),
    component: <Gallery />,
    secondary: true,
  },
  {
    name: 'Event Highlights',
    layout: '/admin',
    path: '/event-highlights',
    icon: (
      <Icon as={MdAutoAwesome} width="20px" height="20px" color="inherit" />
    ),
    component: <EventHighlights />,
    secondary: true,
  },
  {
    name: 'Videos',
    layout: '/admin',
    path: '/videos',
    icon: (
      <Icon as={MdVideoLibrary} width="20px" height="20px" color="inherit" />
    ),
    component: <Videos />,
    secondary: true,
  },
  {
    name: 'Feedbacks',
    layout: '/admin',
    path: '/feedbacks',
    icon: <Icon as={MdFeedback} width="20px" height="20px" color="inherit" />,
    component: <Feedbacks />,
  },
  {
    name: 'Subscribers',
    layout: '/admin',
    path: '/subscribers',
    icon: (
      <Icon as={MdSubscriptions} width="20px" height="20px" color="inherit" />
    ),
    component: <Subscribers />,
  },
  {
    name: 'Settings',
    layout: '/admin',
    path: '/settings',
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    component: <Settings />,
  },
  {
    name: 'About Us',
    layout: '/admin',
    path: '/about-us',
    icon: <Icon as={MdInfo} width="20px" height="20px" color="inherit" />,
    component: <AboutUs />,
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLogin} width="20px" height="20px" color="inherit" />,
    component: <SignIn />,
    noSidebar: true,
  },
];

export default routes;
